module.exports = __webpack_public_path__ + "assets/img/Server7.a71d3b2f.png";